import { Box, CardContent, Grid, Typography } from "@mui/material";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import React from "react";
import { Card } from "react-bootstrap";
import { superAdmin_Data } from "../../../Data/data";
import { useNavigate } from "react-router-dom";
import "./DashboardCard.css";

const DashboardCard = (props) => {
  return (
    <>
      {/* <Grid container spacing={2} className="dashboardCard"> */}
      {/* {superAdmin_Data.map((item, i) => { */}
      {/* return ( */}
      <React.Fragment>
        <Grid item lg={2}>
          <Card
            className="dashboardCard-cardMain"
            onClick={() => props.handleRedirect(props.path)}
          >
            <CardContent>
              <Box className="dashboardCard-cardMain-icon">{props.icon}</Box>
              <Box className="dashboardCard-cardMain-actions">
                <Typography className="dashboardCard-cardMain-actions-label">
                  {props.label}
                </Typography>
                <ChevronRightOutlinedIcon />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </React.Fragment>
      {/* ); */}
      {/* })} */}
      {/* </Grid> */}
    </>
  );
};

export default DashboardCard;
